import React, { createContext, useContext, useRef, useCallback } from 'react';

const NavigationCacheContext = createContext();

export const NavigationCacheProvider = ({ children }) => {
  const cacheRef = useRef({});

  const setCache = useCallback((key, data) => {
    cacheRef.current[key] = {
      ...(cacheRef.current[key] || {}),
      ...data,
      timestamp: Date.now()
    };
  }, []);

  const getCache = useCallback((key) => {
    return cacheRef.current[key] || null;
  }, []);

  const saveScrollPosition = useCallback((key, scrollY) => {
    if (!cacheRef.current[key]) {
      cacheRef.current[key] = {};
    }
    cacheRef.current[key].scrollY = scrollY;
  }, []);

  const clearCache = useCallback((key) => {
    if (key) {
      delete cacheRef.current[key];
    } else {
      cacheRef.current = {};
    }
  }, []);

  return (
    <NavigationCacheContext.Provider value={{ setCache, getCache, saveScrollPosition, clearCache }}>
      {children}
    </NavigationCacheContext.Provider>
  );
};

export const useNavigationCache = () => {
  const context = useContext(NavigationCacheContext);
  if (!context) {
    throw new Error('useNavigationCache must be used within a NavigationCacheProvider');
  }
  return context;
};
